// src/data/reviews.js

export const reviews = [
  {
    id: 1,
    name: 'Оксана, Київська обл.',
    rating: 5,
    text:
      'Отримали дуже детальну консультацію перед покупкою. Парник з агроволокна добре тримає тепло, рослини почуваються значно краще. Навіть після встановлення звертались з питаннями — відповіли без проблем.',
  },
  {
    id: 2,
    name: 'Ірина, Чернівецька обл.',
    rating: 5,
    text:
      'Використовувала парник на дачі, де буваю лише по вихідних. За час відсутності розсада не постраждала, ґрунт залишався вологим. Урожай цього року приємно здивував.',
  },
  {
    id: 3,
    name: 'Володимир, Вінницька обл.',
    rating: 5,
    text:
      'До цього робив саморобні парники з плівки — різниця колосальна. Агроволокно пропускає повітря, але добре захищає від вітру. Рослини ростуть рівномірно.',
  },
  {
    id: 4,
    name: 'Наталія, Хмельницький',
    rating: 5,
    text:
      'Парник використовуємо для огірків і помідорів. Монтується швидко, конструкція міцна. Навіть при різких перепадах температури всередині комфортно для рослин.',
  },
  {
    id: 5,
    name: 'Петро, Черкаська обл.',
    rating: 5,
    text:
      'Брав комплект з поливом на два парники. Дуже зручно — вода подається рівномірно, нічого не пересихає. Догляд за грядками став значно простішим.',
  },
  {
    id: 6,
    name: 'Людмила, Тернопіль',
    rating: 5,
    text:
      'Парник добре захищає від сонця та шкідників. Навесні були заморозки, але рослини не постраждали. Користуємось уже другий сезон.',
  },
  {
    id: 7,
    name: 'Андрій, Рівненська обл.',
    rating: 5,
    text:
      'Купував парник для полуниці. Ягоди стали більші й солодші, ніж раніше. Агроволокно якісне, не рветься, добре тримає форму.',
  },
  {
    id: 8,
    name: 'Світлана, Житомир',
    rating: 3,
    text:
      'Загалом парник свою функцію виконує, рослини ростуть добре. Але доставка затягнулась трохи довше, ніж очікувала. Сам товар якісний, користуватись можна.',
  },
  {
    id: 9,
    name: 'Микола, Полтавська обл.',
    rating: 5,
    text:
      'Брав одразу кілька парників для різних культур. Встановлення просте, матеріали добротні. Значно менше часу витрачаю на догляд.',
  },
  {
    id: 10,
    name: 'Галина, Львівська обл.',
    rating: 5,
    text:
      'Дуже задоволена покупкою. Парник створює гарний мікроклімат, рослини швидко пішли в ріст. Планую докупити ще один наступного сезону.',
  },
];
